import { render, staticRenderFns } from "./EditTid.vue?vue&type=template&id=0f481604&"
import script from "./EditTid.vue?vue&type=script&lang=js&"
export * from "./EditTid.vue?vue&type=script&lang=js&"
import style0 from "./EditTid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports